import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'users'
const verb = 'get'

export default class OspreyUsersSearch extends BaseAction {
    constructor(dataKey) {
        const id = '8d6f17e3-a770-436a-8525-d26053fc3219'
        const path = `/users`
        super(resource, verb, path, id, dataKey)
    }

    search(params) {
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/users/usersSearch.js